exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".skip-link+.skip-link[data-v-19b301cc]{margin-left:1rem}", ""]);

